<template>
  <div class="clearable-input">
    <b-form-input
      :value="value"
      v-bind="$attrs"
      @input="$emit('input', $event)"
    />
    <span v-if="value" class="clearable-input__clear" @click="$emit('input', '')">&times;</span>
  </div>
</template>

<script>
export default {
  name: 'ClearableInput',
  inheritAttrs: false,
  props: {
    value: { type: String, default: '' },
  },
}
</script>

<style scoped>
.clearable-input {
  position: relative;
  display: inline-block;
  width: 100%;
}

.clearable-input__clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #aaa;
  font-size: 1.2em;
  line-height: 1;
  user-select: none;
}

.clearable-input__clear:hover {
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/ClearableInput.vue